import NavigationItem from "components/Modal/ChooseFilesModal/Navigation/NavigationItem";
import { ReactComponent as LocalFilesIcon } from "icons/laptop.svg";
import { ReactComponent as SharepointIcon } from "icons/visi/sharepoint.svg";
import { FILE_SOURCES } from "layout/documentUploader/constants";
import { bool } from "prop-types";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setActiveSource } from "slices/workspace/chooseFilesModalSlice";
import { selectChooseFilesModal } from "slices/workspace/selectors";

import { selectSharepointEnabled } from "../../../../slices/sharepoint/selectors";

const SHAREPOINT_DISABLED =
  "Sharepoint is not configured in your environment. Contact your administrator to enable it.";
const getFileSourcesConfig = (
  sharepointEnabled,
  activeSource,
  showSharepoint
) => {
  const fileSourcesConfig = [];

  fileSourcesConfig.push({
    source: FILE_SOURCES.LOCAL,
    label: "Local Files",
    Icon: LocalFilesIcon,
  });

  if (showSharepoint) {
    fileSourcesConfig.push({
      source: FILE_SOURCES.SHAREPOINT,
      label: "Sharepoint",
      Icon: SharepointIcon,
      disabled: !sharepointEnabled,
      disabledLabel: SHAREPOINT_DISABLED,
    });
  }

  return fileSourcesConfig;
};

const Navigation = ({ showSharepoint = true }) => {
  const dispatch = useDispatch();
  const { activeSource } = useSelector(selectChooseFilesModal);
  const sharepointAuthorized = useSelector(selectSharepointEnabled);
  const fileSourcesConfig = useMemo(
    () =>
      getFileSourcesConfig(sharepointAuthorized, activeSource, showSharepoint),
    [sharepointAuthorized]
  );

  const handleActiveSourceChange = (source) => {
    dispatch(setActiveSource(source));
  };

  return (
    <ul
      className="choose_files_modal__body__navigation"
      data-testid="choose-files-modal-body-navigation"
    >
      {fileSourcesConfig.map(
        ({ source, label, Icon, disabled, disabledLabel }) => (
          <NavigationItem
            key={source}
            source={source}
            active={activeSource === source}
            label={label}
            Icon={Icon}
            disabled={disabled}
            disabledLabel={disabledLabel}
            onClick={handleActiveSourceChange}
          />
        )
      )}
    </ul>
  );
};

Navigation.propTypes = {
  isCollectionsEnabled: bool,
  showCollectionsNav: bool,
  showSharepoint: bool,
};

export default Navigation;
